/// <reference path="../../../../../../typings/index.d.ts" />


module Meevo.Plugins.QuickbooksDesktop {
    'use strict';
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IQuickbooksMainController {
        currentScreen: IScreenList,

        selectedConnection: IConnectionSetupInfo & IAccountsSetup,
        selectedConnectionBackup: IConnectionSetupInfo & IAccountsSetup,
        selectedConnectionListItem: any,
        
        connectionList: IConnectionListItem[],
        screenList: Array<IScreenList>,
        toolTips: IToolTip[],
        isDisableControlButtons: boolean,
        selectedProductTrackingLevel: ProductInventoryTrackingLevel,

        changeScreen: (screen: MainTabScreens) => void,
        getPaymentTypes: () => ng.IPromise<ScreenResult>,
        sendData: () => ng.IPromise<ScreenResult>,
        removeConnection: () => void,
        showDeleteScreen: () => void

        changeStepHandler(): ng.IPromise<ScreenResult>,
        setupConnection(saveFn: Function): ng.IPromise<ScreenResult>, 
        goToNextScreen: (Event) => void,
        goToPreviousScreen: () => void,
        checkUploadingStatus: (successHandler?: Function) => ng.IPromise<ScreenResult>,
        editConnection: () => void,
        checkInputForUnique: (changedValue: string) => ng.IPromise<number>,
        getSelectedAccount: (accountType: IAccountSystemList) => string
    }


    class MainController implements IQuickbooksMainController {
       
        /* Data stores for connection */
        public selectedConnection: IConnectionSetupInfo & IAccountsSetup = this.defaultSelectedConnection;
        public selectedConnectionBackup: IConnectionSetupInfo & IAccountsSetup = this.defaultSelectedConnection;
        public selectedConnectionListItem: any;

        /* Different types of lists */
        public connectionList: IConnectionListItem[];   
        public paymentTypes: IPaymentTypeListItem[];
        public paymentAccountOptions: IPaymentOptions;

        public screenList: Array<IScreenList> = [
            {
                type: MainTabScreens.Welcome,
                headerTitle: () => '',
                viewPath: 'app/plugins/quickbooksDesktop/components/main/welcome.template.html',
            },
            {
                type: MainTabScreens.Create,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/create.template.html',
                nextButtonHandler: () => this.setupConnection((body) => this.apiService.setupConnection(body))
            },
            {
                type: MainTabScreens.ConnectingFile,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/connecting-file.template.html',
                nextButtonHandler: () => this.checkUploadingStatus(() => this.getAccounts())
            },
            {
                type: MainTabScreens.SettingsAccount,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/setting-accounts.template.html',
                nextButtonHandler: () => this.getPaymentTypes(),
                
            },
            {
                type: MainTabScreens.PaymentSetup,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/payment-type-setup.template.html',
                nextButtonHandler: () => this.sendData(),
                isBackButtonShown: true  
            },
            {
                type: MainTabScreens.Finish,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/congratulations.template.html',
                isNextButtonHidden: true,
                isFinishButtonShown: true,
                finishButtonHandler: () => this.finishConnectionSetup(),
            },
            {
                type: MainTabScreens.Edit,
                headerTitle: () => this.dynamicText,
                viewPath: 'app/plugins/quickbooksDesktop/components/main/edit.template.html',
                nextButtonHandler: () => this.processSelectedConnection(),
            },
            {
                type: MainTabScreens.Delete,
                headerTitle: () => this.$translate.instant('LABEL_ACCOUNTSYNC_MAIN_TITLE_REMOVE'),
                viewPath: 'app/plugins/quickbooksDesktop/components/main/delete.template.html',
                isNextButtonHidden: true,
                isCancelButtonHidden: true,
                isFinishButtonShown: true,
                finishButtonHandler: () => this.cancelFlow()
            }
        ];
        public accountSystemList:any;
        public externalAccountList: IAccountInfo[] = [];
        public externalAccountsBackup: IExternalAccount[] = [];
        public defaultAcountsList: IAccountInfo[] = [];

        /* Flags for UI management */
        public currentScreen = this.screenList[0];
        public isDisableControlButtons: boolean = false;
        public selectedProductTrackingLevel: ProductInventoryTrackingLevel = ProductInventoryTrackingLevel.Default;
        public isRemoveSuccessful: boolean = false;
        public isEditingMode: boolean = false;

        /* Others */
        public toolTips: IToolTip[] = [
            { value: ToolTipEnum.ProductIncome, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/productIncome.html' },
            { value: ToolTipEnum.ServiceIncome, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/serviceIncome.html' },
            { value: ToolTipEnum.OtherIncome, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/otherIncome.html' },
            { value: ToolTipEnum.AccountsReceivable, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/accountsReceivable.html' },
            { value: ToolTipEnum.InventoryAssets, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/inventoryAssets.html' },
            { value: ToolTipEnum.CostofGoodsSoldAccount, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/costOfGoodsSoldAccount.html' },
            { value: ToolTipEnum.Liabilities, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/liabilities.html' },
            { value: ToolTipEnum.ExpenseAccount, template: 'app/plugins/accountsync/components/tooltip/tooltipViews/expenseAccount.html' }
        ];
        private disabledPaymentType = 'Cash';
        public accountReceivableName = 'Accounts Receivable';
        public meevoAccountReceivableName = 'Meevo Account Receivable';

        static $inject = [
            'meevo.plugins.quickbooksDesktop.QuickbooksDesktopApi',
            'meevo.components.common.IdentityService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            '$translate',
            '$filter',
            '$q',
        ];

        constructor(
            protected apiService: QuickbooksDesktop.IQuickbooksDesktopApi,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $filter: angular.IFilterService,
            protected $q: angular.IQService
        ) {}

        /**
        * Show the user a specific screen in the Main tab
        * @param {MainTabScreens} screenToApply
        */
        changeScreen(screenToApply: MainTabScreens): void {
            this.currentScreen = this.screenList.find((screen: IScreenList) => screen.type === screenToApply);
        }

        /**
        * Change view when next button clicked
        */
        goToNextScreen(element: Event): void {
            if (element) setTimeout(() => $(element.currentTarget).blur(), 1000);

            this.changeStepHandler().then((stepResult: ScreenResult) => {
                // Go to next page after success
                if (stepResult && stepResult.isNextStepAllowed) {
                    const type = stepResult.screen !== undefined ? stepResult.screen : this.currentScreen.type + 1;
                    this.changeScreen(type);
                }
            })
        }

        /**
        * Handler of next button click for specific screen
        * @returns {ng.IPromise<ScreenResult>}
        */
        changeStepHandler(): ng.IPromise<ScreenResult> {
            return this.currentScreen.nextButtonHandler ? this.currentScreen.nextButtonHandler.call(this) : this.$q.resolve({ isNextStepAllowed: true });
        }

        /**
        * Change screen to previuos
        */
        goToPreviousScreen(): void {
            this.currentScreen.backButtonHandler
                ? this.currentScreen.backButtonHandler()
                : this.changeScreen(this.currentScreen.type - 1);
        }

        /**
         * Handler for cancel button
         * @returns { void }
         */
        cancelFlow(): void {
            this.changeScreen(MainTabScreens.Welcome);
            this.resetFormScreen();
        }

        /**
         * Handler for Finish button
         */
        handleFinish(): void {
            this.currentScreen.finishButtonHandler();
        }

        /**
         * Setup new connection
         * @param {Function} saveFn
         * @returns {ng.IPromise<ScreenResult>}
         */
        setupConnection(saveFn: Function): ng.IPromise<ScreenResult> {
            this.busyService.start();
            return saveFn(this.selectedConnection)
                .then((connection: IApplicationConnection) => {
                    if (!connection) return { isNextStepAllowed: false };

                    this.selectedConnection.applicationConnection = { ...connection }
                    return { isNextStepAllowed: true };
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Check if user uploaded the file to web connector
         * @param {Function} successHandler
         * @returns {ng.IPromise<ScreenResult>}
         */
        checkUploadingStatus(successHandler?: Function): ng.IPromise<ScreenResult> {
            return this.apiService.getConnectionById(this.selectedConnection.applicationConnection.applicationConnectionId)
                .then(({ applicationConnection, accountSetup }: IConnectionSetupInfo & IAccountsSetup) => {
                    const { meevoSummaryCustomerExternalId, meevoSummaryDistributorExternalId, taxAgencyExternalId, undepositedFundsAccountExternalId } = applicationConnection;
                    const connectionIsValid = meevoSummaryCustomerExternalId && meevoSummaryDistributorExternalId && taxAgencyExternalId && undepositedFundsAccountExternalId !== "0";

                    if (connectionIsValid) {
                        this.defaultAcountsList = accountSetup.accounts;
                        return successHandler();
                    }
                    
                    this.modalService.alert('NOTE_ACCOUNTSYNC_DESKTOP_STEPS_REQUIREMENTS');
                    return { isNextStepAllowed: false };
                });
        }

        /**
         * Get all payment types
         * @returns {ng.IPromise<ScreenResult>}
         * */
        getPaymentTypes(): ng.IPromise<ScreenResult> {
            this.busyService.start();
            let requestObj = { criteria: { includeNonMonetary: 0, IncludeInactive: 1, IncludeDeleted: 1, IncludeActive: 1 }, pageNumber: 0, itemsPerPage: 1000 };

            return this.apiService.getPaymentTypeList(requestObj)
                .then((paymentTypes: IPaymentTypeListItem[]) => {
                    this.paymentTypes = paymentTypes;
                    var payment = this.paymentTypes.find(p => p.paymentTypeSId == 25);
                    if (payment != null) {
                        payment.displayName = "Care Credit Integration®";
                    }

                    const isEdititingMode: boolean = !!this.selectedConnection.paymentTypeSetup.items.length;
                    
                    //check if were added new custom payment types
                    const newPaymentTypesWereAdded: boolean = isEdititingMode && this.selectedConnection.paymentTypeSetup.items.length !== paymentTypes.length;

                    if (newPaymentTypesWereAdded) this.selectedConnection.paymentTypeSetup.items.push(...this.findDistinctPayments(paymentTypes));
                    
                    let paymentList: any = isEdititingMode ? this.selectedConnection.paymentTypeSetup.items : paymentTypes;

                    //data for payment drop-down
                    return this.getPaymentTypeList(
                        paymentList,
                        this.externalAccountsBackup);
                })
                .then((paymentAccountOptions: IPaymentOptions) => {
                    this.paymentAccountOptions = paymentAccountOptions;

                    return { isNextStepAllowed: true };
                })
                .finally(() => this.busyService.stop());
        }

        /**
        * Get payments type list
        * @param {any} paymentTypes
        * @param {IExternalAccount[]} externalAccounts
        * @returns {IPaymentOptions}
        */
        private getPaymentTypeList(paymentTypes: any, externalAccounts: IExternalAccount[]): IPaymentOptions {
            let paymentAccountList = {};
            const externalAccountTypes = [
                ExternalAccountTypeEnum.Bank,
                ExternalAccountTypeEnum.ProductIncome,
                ExternalAccountTypeEnum.ServiceIncome,
                ExternalAccountTypeEnum.Income,
                ExternalAccountTypeEnum.OtherCurrentAsset,
                ExternalAccountTypeEnum.OtherAsset,
                ExternalAccountTypeEnum.FixedAsset,
            ];

            const filteredExternalAccount = externalAccounts.filter(externalAccount => new Set(externalAccountTypes).has(externalAccount.accountType));
        
            paymentTypes.forEach((paymentType: IPaymentTypeListItem) => {
                paymentAccountList[paymentType.paymentTypeId || paymentType.id] = filteredExternalAccount.map((externalAccount: IExternalAccount) => {
                    return this.getPaymentAccount(paymentType, externalAccount);
                })
            });

            return paymentAccountList; 
        }

        /**
         * Save full connection
         * @returns {ng.IPromise<ScreenResult>}
         * */
        sendData(): ng.IPromise<ScreenResult> {
            this.busyService.start();
           
            return this.apiService.addAccountsToConnection(this.selectedConnection)
                .then(() => { return { isNextStepAllowed: true }})
                .finally(() => this.busyService.stop());
        }

        /**
         * Prepare payment account for dropdown in Payment setup
         * @param {IPaymentTypeListItem} paymentType
         * @param {IExternalAccount} externalAccount
         * @returns {IPaymentAccount}
         */
        private getPaymentAccount(paymentType: IPaymentTypeListItem, externalAccount: IExternalAccount): IPaymentAccount {
            return {
                paymentTypeAccountExternalId: externalAccount.listID,
                paymentTypeAccountExternalDisplayName: externalAccount.name,
                paymentTypeName: paymentType.displayName || paymentType.paymentTypeName,
                paymentTypeId: paymentType.id || paymentType.paymentTypeId,
                applicationConnectionId: this.selectedConnection.applicationConnection.applicationConnectionId,
                paymentSubCategory: paymentType.paymentSubCategory,
                entityVersion: paymentType.entityVersion,
                accountType: externalAccount.accountType,
                paymentTypeSId: paymentType.paymentTypeSId
            };
        }

        /**
         * Handler for editing connection
         * */
        editConnection(): void {
            this.setDefaultConnectionOrExistingInEdit().then((canProceed: boolean) => {
                canProceed && this.changeScreen(MainTabScreens.Edit);
                this.isEditingMode = true;
            });
        }


        /**
         * Remove connection using it's id
         */
        removeConnection(): void {
            const { applicationConnectionId, entityVersion, applicationConnectionDisplayName } = this.selectedConnectionListItem;

            const message: string = this.translate('MESSAGE_CONFIRM_DELETE_CONNECTION', { connectionName: applicationConnectionDisplayName });

            this.modalService.confirm(message)
                .then(() => {
                    this.busyService.start();

                    return this.apiService.deleteConnection({
                        id: applicationConnectionId,
                        objectStateEnum: ObjectStateEnum.Deleted,
                        entityVersion: entityVersion
                    });
                })
                .then(() => {
                    this.isRemoveSuccessful = true;
                    this.selectedConnectionListItem = null;

                    return this.updateConnectionList();
                })
                .then((connectionList: Array<IConnectionListItem>) => {
                    !connectionList.length && this.changeScreen(MainTabScreens.Welcome);
                })
                .finally(() => this.busyService.stop());;
        }

        /**
         * Show delete view
         * */
        showDeleteScreen(): void {
            this.busyService.start();
            
            this.updateConnectionList()
                .then(() => {
                    this.changeScreen(MainTabScreens.Delete);
                    this.selectedConnectionListItem = this.connectionList[0];
                })
                .finally(() => this.busyService.stop());
        }

        /**
         * Function for checking the uniqueness of the input, which is passed to the local directive
         * @param {string} changedValue
         * @returns {ng.IPromise<number>} promise
         */
        checkInputForUnique(changedValue: string): ng.IPromise<number> {
            if (changedValue !== '' && changedValue !== null && changedValue !== this.selectedConnectionBackup.applicationConnection.applicationConnectionDisplayName) {
                const requestBody = angular.copy(this.defaultAccountCountRequestBody);
                requestBody.criteria.displayName = changedValue;
                return this.apiService.getConnectionsCount(requestBody);
            } else if (changedValue === this.selectedConnectionBackup.applicationConnection.applicationConnectionDisplayName) {
                return this.$q.resolve(0);
            }
        }

        /**
         * Get choosed account for system accountss
         * @param {IAccountSystemList} accountType
         * @returns {string}
         */
        getSelectedAccount(accountType: IAccountSystemList): string {
            let chosenAccount: IAccountInfo;
            if (this.selectedConnectionBackup.accountSetup.accounts[accountType.id - 1]) {
                chosenAccount = this.selectedConnectionBackup.accountSetup.accounts[accountType.id - 1];
            } else if (this.defaultAcountsList[accountType.id - 1] && this.defaultAcountsList[accountType.id - 1].accountExternalId) {
                chosenAccount = _.find(this.defaultAcountsList, (defaultAcount: IAccountInfo) => defaultAcount.accountSId == accountType.accountType);
            }
            if (!this.isEditingMode && chosenAccount && chosenAccount.accountExternalDisplayName === this.meevoAccountReceivableName) return chosenAccount.accountSDisplayName;

            return chosenAccount && chosenAccount.accountExternalDisplayName || this.translate('TEXT_NO_ACCOUNT_SELECTED');
        }

        /**
         * Get system and external accounts
         * @returns {ng.IPromise<ScreenResult>}
         * */
        private getAccounts(): ng.IPromise<ScreenResult> {
            this.busyService.start();

            return this.apiService.getSystemAccounts()
                .then((systemAccount: IAccountSystemList[]) => {
                    this.accountSystemList = systemAccount;
                    this.defaultAcountsList = this.getDefaultAccountsList(this.defaultAcountsList);

                    return this.getExternalAccounts(this.selectedConnection.applicationConnection.applicationConnectionId, this.defaultAcountsList);
                })
                .then((externalAccountList: IAccountInfo[]) => {
                    this.externalAccountList = externalAccountList;
                    return { isNextStepAllowed: true };
                })
                .finally(() => this.busyService.stop());
        }

        /**
         * Get and prepare external accounts for the select when opening a select on the AccountSetup view
         * @param {Guid} applicationConnectionId
         * @param {Array<IAccountInfo>} accountsSystemList
         * @returns {ng.IPromise<IAccountInfo[]>} promise
         */
        private getExternalAccounts(applicationConnectionId: Guid, accountsSystemList: Array<IAccountInfo>): ng.IPromise<IAccountInfo[]> {
            let externalAccountList: IAccountInfo[] = [];
            const baseCategories = _.filter(this.defaultAcountsList, (dft) =>
                dft.accountSId === ExternalAccountTypeEnum.ProductIncome ||
                dft.accountSId === ExternalAccountTypeEnum.ServiceIncome);

            return this.apiService.getExternalAccounts(applicationConnectionId).then((externalAccounts: IExternalAccount[]) => {
                this.externalAccountsBackup = externalAccounts;
                if (externalAccounts) {
                    externalAccounts.forEach((externalAccount: IExternalAccount) => {
                        const accountSystem = _.find(accountsSystemList, (account: IAccountInfo) => account.accountSId === externalAccount.accountType);
                        if (!accountSystem && externalAccount.accountType === ExternalAccountTypeEnum.Income) {
                            baseCategories.forEach((category: IAccountInfo) => {
                                if (category.accountExternalId !== externalAccount.listID)
                                    externalAccountList.push(this.prepareOptionForSelect(category, externalAccount))
                            });
                        };
                        if (accountSystem && accountSystem.accountExternalId !== externalAccount.listID) externalAccountList.push(this.prepareOptionForSelect(accountSystem, externalAccount));
                    })
                }

                return externalAccountList;
            });
        }

        /**
         * Prepare external account for select in AccountSetup view
         * @param {IAccountInfo} accountType
         * @param {IExternalAccount} externalAccount
         * @returns {IAccountSetupInfo}
         */
        private prepareOptionForSelect(accountType: IAccountInfo, externalAccount?: IExternalAccount): IAccountInfo {
            const accountName = externalAccount && externalAccount.name || accountType.accountExternalDisplayName;
            const accountFullName = externalAccount && (externalAccount.name) || accountType.accountExternalFullName;

            return {
                accountSId: accountType.accountSId,
                accountSDisplayName: accountType.accountSDisplayName,
                accountExternalDisplayName: accountName,
                accountExternalFullName: accountFullName,
                accountExternalId: externalAccount && externalAccount.listID || '0',
                displayCategory: accountType.accountSId,
                accountId: accountType.accountId,
                entityVersion: accountType.entityVersion,
                tenantId: accountType.tenantId,
                applicationConnectionId: accountType.applicationConnectionId,
            };
        }

        /**
         * Find unique accounts in arrray and add props
         * @param paymentTypes
         * @returns {Array<any>}
         */
        private findDistinctPayments(paymentTypes): Array<any> {
            return _.filter(paymentTypes, (item: any) => {
                return !_.findWhere(this.selectedConnection.paymentTypeSetup.items, { paymentTypeId: item.id });
            }).map((item: any) => {
                item.paymentTypeAccountExternalDisplayName = 'Undeposited Funds';
                item.paymentTypeId = item.id;
                item.paymentTypeAccountExternalId = this.selectedConnection.applicationConnection.undepositedFundsAccountExternalId;
                return item;
            });
        }

        /**
         * Set first connection as default in dropdown in Edit view
         * @returns {ng.IPromise<boolean>}
         */
        private setDefaultConnectionOrExistingInEdit(): ng.IPromise<boolean> {
            const connectionId = this.selectedConnectionListItem && this.selectedConnectionListItem.applicationConnectionId || '';

            this.selectedConnectionListItem = connectionId ? _.find(this.connectionList, connection => connection.applicationConnectionId === connectionId) : this.connectionList[0];
            return this.getConnection();
        }

        /**
         * Get information about connection by clicking on it in Select on EditConnection view
         * @returns {ng.IPromise<boolean>}
         */
        private getConnection(): ng.IPromise<boolean> {
            this.busyService.start();

            return this.apiService.getConnectionById(this.selectedConnectionListItem.applicationConnectionId)
                .then((data: IConnectionSetupInfo & IAccountsSetup) => {
                    data.accountSetup.accounts = this.$filter<any>('orderBy')(data.accountSetup.accounts, 'accountSId');
                    this.selectedConnection = angular.copy(data);
                    this.selectedConnectionBackup = angular.copy(data);

                    return true;
                })
                .catch(_ => false)
                .finally(() => this.busyService.stop());
        }

        /**
         * Return default accounts list for Account Setup dropdowns
         * @param {IAccountInfo[]} defaultAcountsList
         * @returns {IAccountInfo[]}
         */
        private getDefaultAccountsList(defaultAcountsList: IAccountInfo[]): IAccountInfo[] {
            return defaultAcountsList.map((item: IAccountInfo) => {
                item.accountExternalFullName = item.accountExternalDisplayName;
                item.displayCategory = item.accountSId;
                return item;
            })
        }

        /**
         * Handler for last step in Main tab
         * @returns {ng.IPromise<ScreenResult>}
         * */
        private finishConnectionSetup(): ng.IPromise<ScreenResult> {
            return this.apiService.getConnectionById(this.selectedConnection.applicationConnection.applicationConnectionId)
                .then(({ accountSetup: { subAccounts } }: any) => {
                    const isUpdateSelected = subAccounts.some(subAcc => subAcc.accountSubItemExternalId);

                    if (!isUpdateSelected) {
                        this.modalService.alert('NOTE_ACCOUNTSYNC_DESKTOP_UPDATE_DATA');

                        return this.$q.reject({ isNextStepAllowed: false });
                    }

                    return this.updateConnectionList()
                })
                .then(() => {
                    this.setLatestConnectionId({ connectionId: this.selectedConnection.applicationConnection.applicationConnectionId });
                    this.resetFormScreen();
                    this.changeCurrentStep({ step: QuickbooksDesktopTabsEnum.Sync });

                    this.changeScreen(MainTabScreens.Welcome);
                    return { isNextStepAllowed: true };
                });
        }

        /**
         * Processing selected connection and skipping download file screen
         * */
        private processSelectedConnection(): ng.IPromise<ScreenResult> {
            return this.setupConnection((body) => this.apiService.updateConnection(body)).then(_ => {
                const connectingFileScreen = this.screenList.find(screen => screen.type === MainTabScreens.ConnectingFile);
                return connectingFileScreen.nextButtonHandler().then(({ isNextStepAllowed }): ScreenResult => {
                    return { isNextStepAllowed, screen: MainTabScreens.SettingsAccount };
                });
            });
        }

        /**
         * Check if attached account is exist in external account list
         * @param {IAccountSystemList} accountType
         * @returns {boolean}
         */
        private isAttachedAccountInExternalAccountsList(accountType: IAccountSystemList): boolean {
            const attachedAccountId: string = this.selectedConnectionBackup.accountSetup.accounts[accountType.id - 1] &&
                this.selectedConnectionBackup.accountSetup.accounts[accountType.id - 1].accountExternalId || '0';
            const externalAccountsListForSystemAccount: IAccountInfo[] = this.externalAccountList || [];

            return _.contains(externalAccountsListForSystemAccount.map(externalAccount => externalAccount.accountExternalId), attachedAccountId);
        }

        /**
         * Check if attached payment account is exist in payment account list
         * @param {number} paymentTypeIndex
         * @returns {boolean}
         */
        private isAttachedPaymentAccountInPaymentAccountsList({ paymentTypeAccountExternalDisplayName, accountType, paymentTypeName }: any): boolean {
            if (accountType !== ExternalAccountTypeEnum.OtherCurrentAsset && accountType !== ExternalAccountTypeEnum.CashDrawer) return false;

            return (paymentTypeName === "Cash" && paymentTypeAccountExternalDisplayName === "Meevo Cash Drawer") ||
                (paymentTypeAccountExternalDisplayName.toLowerCase() === 'undeposited funds' && paymentTypeName !== "Cash");
        }

        /**
         * Returns selected option for Payment dropDown in Edit mode
         * @param {IPaymentAccount} account
         */
        private getSelectedPaymentOption(account: IPaymentAccount): boolean {
            const category = _.find(this.selectedConnection.paymentTypeSetup.items, (item) => item.paymentTypeId === account.paymentTypeId);
            return category && category.paymentTypeAccountExternalId === account.paymentTypeAccountExternalId;
        }

        /**
        * Function for showing alert when input is not unique, which is passed to the local directive
        */
        private showAlertForUniqueInput(): void {
            this.modalService.alert('MESSAGE_ALERT_UNIQUE_CONNECTION_VALUE');
        }

        /**
         * Reset variables values wich using in component
         */
        private resetFormScreen(): void {
            this.selectedConnection = this.defaultSelectedConnection;

            this.isDisableControlButtons = false;
            this.selectedConnectionBackup = angular.copy(this.selectedConnection);
            this.selectedConnectionListItem = null;
            this.isRemoveSuccessful = false;
            this.isEditingMode = false;

            this.defaultAcountsList = [];
            this.externalAccountList = [];
        }

        /**
         * Translate using key
         * @param {string} key
         * @param {any} parameters
         * @returns {string}
         */
        private translate(key: string, parameters?: any): string {
            return this.$translate.instant(key, parameters);
        }

        /**
         * Return tooltip template view usind tooltip's id
         * @param {number} tooltipId
         * @returns {string}
         */
        private getToolTipView(tooltipId: number): string {
            return this.toolTips[tooltipId] && this.toolTips[tooltipId].template || '';
        }

        private onDeleteListOpen(): void {
            this.isRemoveSuccessful = false;
        }

        get mainTabScreensEnum() {
            return MainTabScreens;
        }

        get productInventoryTrackingLevel() {
            return ProductInventoryTrackingLevel;
        }

        get dynamicText(): string {
            return this.$translate.instant(this.isEditingMode ? 'LABEL_ACCOUNTSYNC_MAIN_TITLE_EDIT' : 'LABEL_CREATE_CONNECTION');
        }

        get defaultSelectedConnection(): IConnectionSetupInfo & IAccountsSetup {
            return {
                applicationConnection: {
                    applicationConnectionDisplayName: null,
                    applicationConnectionUserName: this.identityService.current().displayName,
                    applicationConnectionPassword: null,
                    undepositedFundsAccountExternalId: "0",
                    externalApplicationEnum: ExternalApplicationEnum.QuickbooksDesktop,
                    applicationConnectionTypeEnum: ConnectionVersionEnum.Local,
                    objectStateEnum: ObjectStateEnum.Active,
                    entityVersion: 0,
                    includeMonetaryPayments: true
                },
                accountSetup: {
                    accounts: []
                },
                paymentTypeSetup: {
                    items: []
                }
            }
        }

        get defaultAccountCountRequestBody(): IAccountCountRequest {
            return {
                criteria: {
                    displayName: null,
                    url: null,
                    realmId: null,
                    objectState: ObjectStateEnum.Active,
                    filter: null,
                    maintenanceMode: true,
                    isGlobal: true
                },
                asLocationId: this.identityService.locationId
            }
        };

        get externalAccountTypeEnum() {
            return ExternalAccountTypeEnum;
        };

        // Binded methods
        updateConnectionList(): any { }
        changeCurrentStep(step: any): any { };
        setLatestConnectionId(connectionId: any): void { }
    }

    class MainComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/quickbooksDesktop/components/main/index.template.html';
        controller = MainController;
        controllerAs = 'model';
        bindings: any = {
            connectionList: '=',
            updateConnectionList: '&',
            changeCurrentStep: '&',
            setLatestConnectionId: '&',
        };
    }

    angular.module('meevo.plugins.quickbooksDesktop')
        .component('quickbooksDesktopMainComponent', new MainComponent());
}
